// @flow
import React, { Component, Fragment } from 'react';
import Icon from '../../../icon/icon.js';
import { convertToActualWeight } from '../weight-and-balance.helpers';

type Props = {|
  +type: 'pilot' | 'passenger',
  +row: number,
  +col: number,
  +data?: ?{
    fullName: string,
    weight: number,
    unit: string
  },
  isPilotRight: boolean,
  onAdd: () => void,
  onEdit: () => void,
  onRemove: () => void,
  onDrop?: () => void
|};

class PassengerSeat extends Component<Props> {
  constructor(props: Props) {
    super(props);

    this.handleDragStart = this.handleDragStart.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
    this.handleDragIconClick = this.handleDragIconClick.bind(this);

    this.state = {
      isClickDrag: false,
      isDrag: false,
      isDragEnter: false
    };
  }

  handleDragStart(event) {
    const { row, col } = this.props;

    event.dataTransfer.setData('row', row);
    event.dataTransfer.setData('col', col);

    this.setState({ isDrag: true });
  }

  handleDragEnd() {
    this.setState({ isClickDrag: false, isDrag: false });
  }

  handleDragIconClick() {
    this.setState({ isClickDrag: true });
  }

  handleDragOver(event) {
    event.preventDefault();
  }

  handleRemove() {
    const { onRemove, row, col } = this.props;
    onRemove(row, col);
  }

  handleDrop(event) {
    const { onDrop, row, col } = this.props;
    onDrop(event, row, col);
  }

  getClassNames() {
    const { type, isPilotRight } = this.props;
    const { isDrag, isDragEnter } = this.state;
    const classes = ['seat-drag-container'];

    if (type === "pilot" && isPilotRight) {
      classes.push('seat--pilot');
    }

    if (isDrag) {
      classes.push('seat--drag');
    }

    if (isDragEnter) {
      classes.push('seat--enter');
    }

    return classes.join(' ');
  }

  render() {
    const {row, col, data, onAdd, onEdit} = this.props;
    const {isClickDrag} = this.state;

    const draggable = String(Boolean(data) && isClickDrag);
    const seatData = JSON.stringify({ row, col });

    return (
      <div
        onDrop={this.handleDrop}
        onDragOver={this.handleDragOver}
        className={this.getClassNames()}
      >
        <div
          className={`seat-container ${data ? 'view-passengers' : 'add-passengers'}`}
          onDragStart={this.handleDragStart}
          onDragEnd={this.handleDragEnd}
          draggable={draggable}
        >
          <div className="seat-handle" />
          <div className="seat-panel">
            {data ? (
              <Fragment>
                <div className="flex-1 drag-wrapper">
                  <button type="button" className="seat-btn" onMouseDown={this.handleDragIconClick}>
                    <Icon width="8px" height="13px" name="drag" className="icon-primary" />
                  </button>
                </div>
                <div className="seat-info flex-1">
                  <div>
                    <h5>{data.fullName}</h5>
                    <p className="d-flex a-center j-center">
                      <Icon width="11px" height="11px" name="weight" className="icon-primary" />
                      <span className="p-l-4">
                        {convertToActualWeight(data.weight, data.unit)} {data.unit}
                      </span>
                    </p>
                  </div>
                </div>

                <div className="seat-btn-container flex-1">
                  <button type="button" className="seat-btn" onClick={onEdit} data-seat={seatData}>
                    <Icon width="11px" height="11px" name="pencil-fill" className="icon-primary" />
                  </button>

                  <button type="button" className="seat-btn" onClick={this.handleRemove}>
                    <Icon width="11px" height="11px" name="trash-fill" className="icon-primary" />
                  </button>
                </div>
              </Fragment>
            ) : (
              <button
                type="button"
                className="btn-add-passengers"
                onClick={onAdd}
                data-seat={seatData}
              >
                <Icon width="14px" height="14px" name="plus" className="icon-primary" />
                <p>Add Passenger</p>
              </button>
            )}
          </div>
          <div className="seat-handle" />
        </div>
      </div>
    );
  }
}

export default PassengerSeat;
